import {
    VuexModule,
    Module,
    Mutation,
    Action,
    getModule,
} from 'vuex-module-decorators'

import {
    crmService,
    CrmOrderInterface,
    CrmProduktInformaceInterface,
} from '@/services/CrmService'

// source: https://www.npmjs.com/package/vuex-module-decorators

@Module({ namespaced: true })
// export const order = {
export class order extends VuexModule {
    // namespaced: true,
    crm: CrmOrderInterface = {
        id_historie: 0,
        hash_objednavky: '',
        cislo_faktury: 0,
        cena: 0,
    }
    @Mutation
    setOrder(crmOrder: CrmOrderInterface) {
        this.crm = crmOrder
    }

    @Action
    async updateOrder(price: number) {

        await this.context.dispatch(
            'loader/setLoader',
            'Vytvářím objednávku ...',
            {
                root: true,
            }
        )

        // development mock pro testovani bez API
        /*
                if (process.env.NODE_ENV == 'development') {
                    console.log(
                        'v development env neukladam objednávku, vracím fake udaje!'
                    )

                    commit('setOrder', {
                        hash_objednavky: 'blablabla',
                        id_historie: 1,
                        cislo_faktury: '001',
                        cena: 1250.18,
                    })
                    resolve(1)
                    return
                }
                */
        //-----------------------------------------

        //   FirmApi.createOrder(
        //       rootState.config.crm,
        //       rootState.firm.result.id_firmy,
        //       rootState.firm.result.opravny_kod,
        //       price,
        //       rootState.config.sandbox,
        //       rootState.firm.presentation.id,
        //       rootState.user.id,
        //       rootState.user.token,
        //       rootState.firm.order_options.payment_method
        //   )
        //       .then(function(response) {
        //           /*
        // {"results":{"hash_objednavky":"5d91adba97592","id_historie":1,"cislo_faktury":"1","id_firmy":5000000,"opravny_kod":"2d99532ba898b61754bee9649","cena":1512.5,"sandbox":1},"status":true}
        //  */
        //
        //           // console.log(response)
        //           const {
        //               hash_objednavky,
        //               id_historie,
        //               cislo_faktury,
        //               cena,
        //           } = response.data.results
        //           commit('setOrder', {
        //               hash_objednavky,
        //               id_historie,
        //               cislo_faktury,
        //               cena,
        //           })
        //           resolve(id_historie)
        //       })
        //       .catch(error => {
        //           console.log(error)
        //           reject(error)
        //       })

        let response = await crmService.getObjednavkaZalozeni({
            crm: this.context.rootState.config.crm,
            id_firmy: this.context.rootState.firm.result.id_firmy,
            opravny_kod: this.context.rootState.firm.result.opravny_kod,
            platba: this.context.rootState.firm.order_options.payment_method,
            cena_s_dph: price,
            sandbox: this.context.rootState.config.sandbox,
        })

        // if (response.status !== 200) {
        //     await this.context.dispatch(
        //         'loader/setLoader',
        //         'Došlo k chybě při vytváření objednávky...',
        //         {
        //             root: true,
        //         }
        //     )
        //     return 0
        // }

        // const {
        //     hash_objednavky,
        //     id_historie,
        //     cislo_faktury,
        //     cena,
        // } = response.data.results
        // let crmOrder: CrmOrderInterface

        if (this.context.rootState.config.sandbox == 1) {
            // crmOrder = {
            //     id_historie: 1,
            //     hash_objednavky: 'test',
            //     cislo_faktury: 1,
            //     cena: price
            // }
            this.context.commit('setOrder', {
                id_historie: 1,
                hash_objednavky: 'test sandbox',
                cislo_faktury: 1,
                cena: price,
            })
        } else {
            this.context.commit('setOrder', {
                id_historie: response.data.objednavka.id_historie,
                hash_objednavky: response.data.objednavka.hash_objednavky,
                cislo_faktury: 1,
                cena: price,
            })
        }

        // console.log(this.crm, 'crm')

        // Katalog firem: přednostní zápis
        response = await crmService.getProduktInformace(121)
        let crmProduktInformace: CrmProduktInformaceInterface =
            response.data.produkt_informace

        // 12x Katalog firem: přednostní zápis
        response = await crmService.postNakup({
            crm: this.context.rootState.config.crm,
            id_firmy: this.context.rootState.firm.result.id_firmy,
            opravny_kod: this.context.rootState.firm.result.opravny_kod,
            id_historie: this.crm.id_historie,
            hash_objednavky: this.crm.hash_objednavky,
            id_produktu: 121,
            pocet: 12,
            cena_bez_dph: crmProduktInformace.cena_bez_dph * 12,
            sandbox: this.context.rootState.config.sandbox,
        })

        // Karta firmy
        response = await crmService.getProduktInformace(3)
        crmProduktInformace = response.data.produkt_informace

        // 12x Karta firmy
        response = await crmService.postNakup({
            crm: this.context.rootState.config.crm,
            id_firmy: this.context.rootState.firm.result.id_firmy,
            opravny_kod: this.context.rootState.firm.result.opravny_kod,
            id_historie: this.crm.id_historie,
            hash_objednavky: this.crm.hash_objednavky,
            id_produktu: 3,
            pocet: 12,
            cena_bez_dph: crmProduktInformace.cena_bez_dph * 12,
            sandbox: this.context.rootState.config.sandbox,
        })
        // this.context.commit('setOrder', this.crm)

        return this.crm.id_historie
    }
}


// export const OrderModule = getModule(order, store)
